import { mapToList } from "./utils";

// 清分方式
export const EnumRoyaltyMethod = {
  // 差额回款
  A: 1,
};

export const RoyaltyMethodToTextMap = new Map([
  [EnumRoyaltyMethod.A, "差额回款"],
]);

export const RoyaltyMethodList = mapToList(RoyaltyMethodToTextMap);
